module.exports = __webpack_public_path__ + "static/assets/img/remote_work_cam.3f3a0b1f.svg";